import React from 'react';

// Floating AI action bubble — persistent bottom-right, mirrors the pattern
// used across the TK platform (violet gradient, gentle pulse).  Clicking it
// takes the user straight to the TK Analyst view.
const FloatingAIButton = ({ onClick, hidden }) => {
  if (hidden) return null;
  return (
    <button
      data-testid="floating-ai-button"
      onClick={onClick}
      aria-label="Ask TK Analyst"
      className="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-gradient-to-br from-violet-500 via-indigo-500 to-purple-600 shadow-lg shadow-indigo-500/30 hover:shadow-indigo-500/50 hover:scale-105 transition-all flex items-center justify-center group"
    >
      <span className="absolute inset-0 rounded-full bg-gradient-to-br from-violet-400 to-indigo-400 opacity-40 group-hover:opacity-70 animate-pulse" />
      <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 relative">
        <path d="M12 3l1.9 4.1L18 9l-4.1 1.9L12 15l-1.9-4.1L6 9l4.1-1.9L12 3z" />
        <path d="M19 15l.9 1.9L22 18l-2.1.1L19 20l-.9-1.9L16 18l2.1-.1L19 15z" />
      </svg>
    </button>
  );
};

export default FloatingAIButton;
